/**
 * Coid 2.0 server
 * Coid 2.0 server API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum DisputeOperation {
    OPEN = 'OPEN',
    REVIEW = 'REVIEW',
    REQUEST_NPCK_DOCS = 'REQUEST_NPCK_DOCS',
    PROVIDE_NPCK_DOCS = 'PROVIDE_NPCK_DOCS',
    REQUEST_BANK_DOCS = 'REQUEST_BANK_DOCS',
    PROVIDE_BANK_DOCS = 'PROVIDE_BANK_DOCS',
    ACCEPT = 'ACCEPT',
    REJECT = 'REJECT',
    SOLVE = 'SOLVE',
    TO_ARBITRATE = 'TO_ARBITRATE',
    PROVIDE_ARBITRATION_DOCS = 'PROVIDE_ARBITRATION_DOCS',
    RESEND = 'RESEND',
    RECALL = 'RECALL',
    EDIT = 'EDIT',
    REQUEST_CHBK = 'REQUEST_CHBK',
    ACCEPT_CHBK = 'ACCEPT_CHBK',
    REJECT_CHBK = 'REJECT_CHBK',
    CREATE_CHBK = 'CREATE_CHBK'
}

